/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialGroupRequest } from './FinancialGroupRequest';
import {
    FinancialGroupRequestFromJSON,
    FinancialGroupRequestFromJSONTyped,
    FinancialGroupRequestToJSON,
    FinancialGroupRequestToJSONTyped,
} from './FinancialGroupRequest';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * 
 * @export
 * @interface MedicalPersonResponse
 */
export interface MedicalPersonResponse {
    /**
     * the unique identifier of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    personId?: string;
    /**
     * the firstname of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    firstname?: string;
    /**
     * the lastname of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    lastname?: string;
    /**
     * the role of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    role?: string;
    /**
     * the gender of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    gender?: string;
    /**
     * the birthdate of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    birthdate?: string;
    /**
     * the title of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    title?: string;
    /**
     * the healthPro type of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    healthProType?: string;
    /**
     * the healthPro number of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    luHealthProNumber?: string;
    /**
     * the nlp preference of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    nlpPref?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof MedicalPersonResponse
     */
    favoritePhone?: PhoneNumber;
    /**
     * the favorite email of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    favoriteEmail?: string;
    /**
     * the favorite language of the person
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    favoriteLanguage?: string;
    /**
     * SSN number for Luxtrust authentication
     * @type {string}
     * @memberof MedicalPersonResponse
     */
    ssnLt?: string;
    /**
     * 
     * @type {FinancialGroupRequest}
     * @memberof MedicalPersonResponse
     */
    financialGroup?: FinancialGroupRequest;
    /**
     * Checks if user have access to the portal
     * @type {boolean}
     * @memberof MedicalPersonResponse
     */
    modulePortalPatient?: boolean;
}

/**
 * Check if a given object implements the MedicalPersonResponse interface.
 */
export function instanceOfMedicalPersonResponse(value: object): value is MedicalPersonResponse {
    return true;
}

export function MedicalPersonResponseFromJSON(json: any): MedicalPersonResponse {
    return MedicalPersonResponseFromJSONTyped(json, false);
}

export function MedicalPersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalPersonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'] == null ? undefined : json['personId'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'role': json['role'] == null ? undefined : json['role'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'title': json['title'] == null ? undefined : json['title'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'luHealthProNumber': json['luHealthProNumber'] == null ? undefined : json['luHealthProNumber'],
        'nlpPref': json['nlpPref'] == null ? undefined : json['nlpPref'],
        'favoritePhone': json['favoritePhone'] == null ? undefined : PhoneNumberFromJSON(json['favoritePhone']),
        'favoriteEmail': json['favoriteEmail'] == null ? undefined : json['favoriteEmail'],
        'favoriteLanguage': json['favoriteLanguage'] == null ? undefined : json['favoriteLanguage'],
        'ssnLt': json['ssnLt'] == null ? undefined : json['ssnLt'],
        'financialGroup': json['financialGroup'] == null ? undefined : FinancialGroupRequestFromJSON(json['financialGroup']),
        'modulePortalPatient': json['modulePortalPatient'] == null ? undefined : json['modulePortalPatient'],
    };
}

export function MedicalPersonResponseToJSON(json: any): MedicalPersonResponse {
    return MedicalPersonResponseToJSONTyped(json, false);
}

export function MedicalPersonResponseToJSONTyped(value?: MedicalPersonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'role': value['role'],
        'gender': value['gender'],
        'birthdate': value['birthdate'],
        'title': value['title'],
        'healthProType': value['healthProType'],
        'luHealthProNumber': value['luHealthProNumber'],
        'nlpPref': value['nlpPref'],
        'favoritePhone': PhoneNumberToJSON(value['favoritePhone']),
        'favoriteEmail': value['favoriteEmail'],
        'favoriteLanguage': value['favoriteLanguage'],
        'ssnLt': value['ssnLt'],
        'financialGroup': FinancialGroupRequestToJSON(value['financialGroup']),
        'modulePortalPatient': value['modulePortalPatient'],
    };
}

